// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-controls {
  padding: 5px 5px 0px 0px;
  display: flex;
  justify-content: end;
  background-color: rgb(237, 237, 237);

  .control-button {
    margin-left: 5px;
    margin-top: 10px;
    margin-right: 10px;
  }

  .top-row {
    margin-bottom: 0px;
  }

  .add-button {
    margin-top: 13px;
    margin-left: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./projects/ert/src/app/shared/table-controls/table-controls.component.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,aAAa;EACb,oBAAoB;EACpB,oCAAoC;;EAEpC;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".table-controls {\n  padding: 5px 5px 0px 0px;\n  display: flex;\n  justify-content: end;\n  background-color: rgb(237, 237, 237);\n\n  .control-button {\n    margin-left: 5px;\n    margin-top: 10px;\n    margin-right: 10px;\n  }\n\n  .top-row {\n    margin-bottom: 0px;\n  }\n\n  .add-button {\n    margin-top: 13px;\n    margin-left: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
